export function capitalizeWords(text: string | undefined): string {
    if (!text) {
        return '';
    }
    return text
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

type RichTextNode = {
    nodeType: string;
    value?: string;
    content?: RichTextNode[];
};

export const extractFormattedText = (
    node: RichTextNode,
    indentLevel = 0
): string => {
    if (!node) {
        return '';
    }

    const indent = ' '.repeat(indentLevel * 2);
    let text = '';

    if (node.nodeType === 'text' && node.value) {
        text += `${indent}${node.value}`;
    }

    if (node.content && node.content.length > 0) {
        text += node.content
            .map((childNode) => extractFormattedText(childNode, indentLevel))
            .join('\n');
    }

    return text;
};

export const extractPlainText = (node: RichTextNode): string => {
    if (node.nodeType === 'text' && node.value) {
        return node.value.replace(/[\n\t]/g, '');
    }

    if (node.content && node.content.length > 0) {
        return node.content.map(extractPlainText).join('');
    }

    return '';
};
